import React from 'react';
import { describeIdRequests, IdRequestFields } from '../utils/idRequestHistory';

type Info = IdRequestFields | null | undefined;

/**
 * The ID-request lines in the claim panel for a client who is not yet
 * verified (#659): first and last request dates and how many were sent, then
 * whether we're still waiting or reminders have stopped.
 */
export const IdRequestStatus: React.FC<{ info: Info }> = ({ info }) => {
  const { summary, stopped } = describeIdRequests(info);
  if (!summary) {
    return (
      <>
        No ID verification request sent yet.
        {stopped && (<><br />{stopped}</>)}
      </>
    );
  }
  return (
    <>
      {`ID requested: ${summary}`}
      <br />
      {stopped ?? 'Awaiting client response.'}
    </>
  );
};

/** The same history as one row, for a client who is already verified. Nothing if no request was sent. */
export const IdRequestHistoryRow: React.FC<{ info: Info; style?: React.CSSProperties }> = ({ info, style }) => {
  const { summary } = describeIdRequests(info);
  if (!summary) return null;
  return (
    <div style={{ marginBottom: '8px', ...style }}>
      <strong>ID Requested:</strong>{' '}{summary}
    </div>
  );
};
